import { LEAVE_RULES_VIOLATION_REASON } from 'domain/shared/leave';
import { FieldProps, EnumField } from 'framework/ui/field';

const RulesViolationReasonField = (props: FieldProps) => {
  return <EnumField {...props} options={LEAVE_RULES_VIOLATION_REASON} />;
};

export default RulesViolationReasonField;
